import type { Release } from '@central/api';

/** The newest release that has an installer, if any; releases are newest first. */
export function latestInstaller(releases: Release[] | undefined): Release | undefined {
  return releases?.find((r) => r.installerUrl);
}
